import { t } from '../../app/i18n';

export default {
  
  NEZODPOVEDANA: 'NEZODPOVEDANA',
  ZODPOVEDANA: 'ZODPOVEDANA',
  ZODPOVEDANA_CEZ_TELEFON: 'ZODPOVEDANA_CEZ_TELEFON',
  BEZ_ODPOVEDE: 'BEZ_ODPOVEDE'

}


export const translation = {
  
  NEZODPOVEDANA: t('Nezodpovedaná'),
  ZODPOVEDANA: t('Zodpovedaná'),
  ZODPOVEDANA_CEZ_TELEFON: t('Zodpovedaná cez telefón'),
  BEZ_ODPOVEDE: t('Bez odpovede'),
};


// WEBPACK FOOTER //
// ./src/common/enums/helpStatus.js